import React from 'react'
import { Content } from '../../components'
import { editorials } from './editorials/articles'

export const PublicationArchivePage = () => {
  return (
    <Content padding="0">
      <main
        style={{
          backgroundColor: '#f3efe7',
          color: '#171714',
          minHeight: '100vh',
          padding: '80px clamp(20px, 7vw, 110px)',
        }}
      >
        <div
          style={{
            maxWidth: '1100px',
            margin: '0 auto',
          }}
        >
          <span
            style={{
              display: 'block',
              marginBottom: '18px',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '11px',
              fontWeight: 700,
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}
          >
            Made to Wear
          </span>

          <h1
            style={{
              margin: '0 0 24px',
              fontSize: 'clamp(48px, 8vw, 96px)',
              fontWeight: 400,
              lineHeight: '1',
            }}
          >
            Publication Archive
          </h1>

          <p
            style={{
              maxWidth: '700px',
              margin: '0 0 80px',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '18px',
              lineHeight: '1.8',
            }}
          >
            Explore every editorial published in Made to Wear.
          </p>

          <div
  style={{
    borderTop: '1px solid #171714',
  }}
>
  {editorials
    .filter((article) => article.publishedAt)
    .sort(
      (firstArticle, secondArticle) =>
        new Date(secondArticle.publishedAt).getTime() -
        new Date(firstArticle.publishedAt).getTime(),
    )
    .map((article) => (
      <article
        key={article.slug}
        style={{
          display: 'grid',
          gridTemplateColumns: '180px minmax(0, 1fr) auto',
          gap: '30px',
          alignItems: 'center',
          padding: '34px 0',
          borderBottom: '1px solid #171714',
        }}
      >
        <div>
          <span
            style={{
              display: 'block',
              marginBottom: '10px',
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '10px',
              fontWeight: 700,
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}
          >
            {article.category}
          </span>

          <time
            dateTime={article.publishedAt}
            style={{
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '14px',
              lineHeight: '1.5',
            }}
          >
            {new Date(
              `${article.publishedAt}T00:00:00`,
            ).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            })}
          </time>
        </div>

        <div>
          <h2
            style={{
              margin: '0 0 12px',
              fontSize: 'clamp(28px, 4vw, 48px)',
              fontWeight: 400,
              lineHeight: '1.05',
            }}
          >
            {article.title}
          </h2>

          <p
            style={{
              maxWidth: '680px',
              margin: 0,
              fontFamily: 'Arial, Helvetica, sans-serif',
              fontSize: '16px',
              lineHeight: '1.7',
            }}
          >
            {article.summary}
          </p>
        </div>

        <a
          href={`/madetowear/${article.slug}`}
          style={{
            color: '#171714',
            fontFamily: 'Arial, Helvetica, sans-serif',
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '2px',
            textDecoration: 'none',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
          }}
        >
          Continue Reading →
        </a>
      </article>
    ))}
</div>

        </div>
      </main>
    </Content>
  )
}
